/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './single-fan-overview.scss';

/* eslint-disable import/no-unresolved, import/default */

import pageTemplate from './single-fan-overview.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.singleFanOverview', [])
    .directive('agSingleFanOverview', SingleFanOverview)
    .name;

/*@ngInject*/
function SingleFanOverview() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '=',
            aeration: '='
        },
        controller: SingleFanController,
        controllerAs: 'vm',
        templateUrl: pageTemplate
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function SingleFanController($scope, $filter, $translate, $q, $log, types, agTypes, agUtils, siloService, unitService, userService) {

    let vm = this;

    vm.agTypes = agTypes;
    vm.loading = false;
    vm.latestValuesSubscriptionOptions = {
        callbacks: {
            onDataUpdated: onDataUpdated,
            onDataUpdateError: onDataUpdateError,
            dataLoading: function(subscription) {
                vm.loading = subscription.loadingData;
            }
        },
        useDashboardTimewindow: false
    };

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';
    vm.stateValue = stateValue;
    vm.resolveIcon = resolveIcon;
    vm.selectAeration = selectAeration;

    vm.flotSettings = {
        shadowSize: 0,
        yaxis: {
            showLabels: false,
            min: 0,
            max: 1.25
        },
        xaxis: {
            showLabels: false
        },
        grid: {
            outlineWidth: 0,
            margin: 0,
            minBorderMargin: 0,
            tickColor: 'rgba(255, 255, 255, 0)' // Workaround to hide grid lines
        }
    };

    vm.flotKeySettings = {
        lineWidth: 1,
        axisTicksFormatter: `if (value >= 0 && value <=1 ) { 
                                return value < 1 ? '${$translate.instant('ag.aeration.off')+''}' : '${$translate.instant('ag.aeration.on')+''}'; 
                             } else {
                                return '';
                             };`,
        tooltipValueFormatter: `return value == 1 ? '${$translate.instant('ag.aeration.on')+''}' : '${$translate.instant('ag.aeration.off')+''}';`
    };

    $scope.$watch('vm.aeration', function() {
        if (vm.aeration && vm.showData) {
            loadAerationInformation();
        }
    });

    $scope.$on('$destroy', function() {
        reset();
    });

    function loadAerationInformation() {

        if (vm.aeration) {
            vm.loading = true;

            var latestValuesSubscriptionsInfo = [{
                type: types.datasourceType.entity,
                entityType: types.entityType.asset,
                entityId: vm.aeration.id.id,
                entityName: vm.aeration.name,
                timeseries: [
                    {name: vm.agTypes.telemetry.aeration.state}
                ]
            }];
            vm.ctx.subscriptionApi.createSubscriptionFromInfo (
                types.widgetType.latest.value, latestValuesSubscriptionsInfo, vm.latestValuesSubscriptionOptions, false, true).then(
                function(subscription) {
                    vm.latestValuesSubscription = subscription;
                }
            );

            vm.aerationStateHistorySubscriptionsInfo = [{
                type: types.datasourceType.entity,
                entityType: types.entityType.asset,
                entityId: vm.aeration.id.id,
                entityName: vm.aeration.name,
                timeseries: [
                    {
                        name: agTypes.telemetry.aeration.state,
                        label: $translate.instant('ag.aeration.state'),
                        color: agTypes.colors.normalColor,
                        postFuncBody: "return value == 'on' ? 1 : 0;"
                    }
                ]
            }];

            vm.loading = false;
        }
    }

    function stateValue(state) {
        if (state === 'on') {
            return $translate.instant('ag.aeration.on');
        } else if (state === 'off') {
            return $translate.instant('ag.aeration.off');
        } else {
            return '';
        }
    }

    function reset() {
        if (vm.latestValuesSubscription) {
            vm.ctx.subscriptionApi.removeSubscription(vm.latestValuesSubscription.id);
        }
        resetValues();
    }

    function resetValues() {
        vm.currentState = '';
    }

    function onDataUpdated(subscription, apply) {
        var data = subscription.data;
        for (var i=0;i<data.length;i++) {
            var datasourceData = data[i];
            var val = getValue(datasourceData);
            switch (datasourceData.dataKey.name) {
                case vm.agTypes.telemetry.aeration.state:
                    vm.currentState = val;
                    break;
            }
        }
        if (apply) {
            $scope.$digest();
        }
    }

    function onDataUpdateError(subscription, e) {
        $log.error(e);
    }

    function getValue(keyData) {
        if (keyData && keyData.data && keyData.data[0] && angular.isDefined(keyData.data[0][1])) {
            return keyData.data[0][1];
        } else {
            return '';
        }
    }

    function resolveIcon(aerationType) {
        return aerationType === agTypes.aerationType.alarm ? "ag:aeration_alarm" : "ag:aeration";
    }

    function selectAeration() {
        let params = angular.copy(vm.ctx.stateController.getStateParams());
        params.entityId = vm.aeration.id;
        params.entityName = vm.aeration.name;
        params.entityLabel = vm.aeration.label;
        params.aerationType = vm.aeration.aerationType;
        const targetState = agTypes.clientState.assetStates[vm.aeration.type];
        vm.ctx.stateController.updateState(targetState, params, true);
    }
}
